import React, { Component } from 'react'

import { TranslatorProvider } from 'react-translate'
import { StickyContainer } from 'react-sticky'

import AlertLJ from '../containers/AlertLJ'
import Header from '../features/commons/Header/Header.container'
import { updateMetaTitle } from '../utils/seoUtilities'

export default class App extends Component {

  constructor(props){
    super(props)
    this.onBackButton = this.onBackButton.bind(this)
    window.addEventListener('popstate', this.onBackButton)
  }

  onBackButton() {
    let q = this.props.urlLocation.query? JSON.parse(this.props.urlLocation.query.q) : null
    this.props.backbutton(q)
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.props.loadCategoryTypes()
    this.props.loadSectors()
    this.props.loadSubsidiaries()
    this.props.loadPropertyTypes()
    this.props.loadAllAdministrativeAereas()

    // check if there are params, if it is true, load them
    if (this.props.urlLocation.query && this.props.urlLocation.query.q) {
      this.props.loadParamsFromURL(JSON.parse(this.props.urlLocation.query.q))
    }
  }

  componentDidUpdate() {
    const { urlLocation, operation_types, operation_type, originPath } = this.props
    updateMetaTitle(urlLocation, operation_types, operation_type, originPath)
  }

  render() {
    const { main, menu, footer, translations } = this.props
    return (
      <TranslatorProvider translations={translations}>
      <div>
        <StickyContainer className='sticky-example'>
          <AlertLJ />
          <Header translations={translations} />
          <div className={`${!menu && 'header-menu-padding-container'}`}>
            {menu}
          </div>
          <main className='Site-content'>
            {main}
          </main>
          <div>
            {footer}
          </div>
        </StickyContainer>
      </div>
      </TranslatorProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js